// extracted by mini-css-extract-plugin
export default {"wrapper":"ieW3b","title":"qdpEP","container":"pNfW4"};